module.exports = __webpack_public_path__ + "static/website-mobile-614893a917f89834cb32ef5bc9c3c035.jpg";